module.exports = __webpack_public_path__ + "69fa14d2ba9093a5c9185b546bdb9fba.ttf";